export default {
  label: 'Tags',
  placeholder: 'All',
};
